let availableChestTypes = [
  "Au Natural",
  "Flap Reconstruction",
  "Flat",
  "Implants",
  "Lumpectomy",
  "Mastectomy",
  "Unilateral",
];

function initChangeTypeOnPPD() {
  $(".type-option").on("click", function () {
    let new_chest_type = $(this).data("option");
    setChestType(new_chest_type);
    setTimeout(function () {
      rebuildImagesListForRecommendation();
    }, 3000);
  });
}

function rebuildImagesListForRecommendation(default_chest_type) {
  let selected_chest_type = getCookie("chest-type");

  if (
    (selected_chest_type == "" || selected_chest_type == null) &&
    default_chest_type != ""
  ) {
    selected_chest_type = default_chest_type;
  }

  if (selected_chest_type != "" && typeof selected_chest_type != "undefined") {
    $(".recommendation-product-card").each(function () {
      let productElement = $(this);
      let active_color = $(this)
        .find("span.product-card__color.active")
        .data("option");
      let product_handle = productElement.data("product-handle");
      let product_id = productElement.data("product-id");
      let productMainImage = "";
      let productHoverImage = "";

      $(`#all_images_for_color_${product_id}`).empty();

      $(this).find(`.product-card__colors span`).first().click();

      $.ajax({
        url: `/products/${product_handle}.js`,
        success: function (dataRes) {
          dataRes.media.forEach((element) => {
            if (element.alt != "" && element.alt != null) {
              let arrImageInfo = element.alt.split(" / ");
              if (arrImageInfo != "") {
                if (arrImageInfo.length > 1) {
                  let image_color_name = arrImageInfo[0];
                  let arrChestInfo = arrImageInfo[1].split(" & ");

                  if (arrChestInfo.length > 1) {
                    let imageChestType = arrChestInfo[0];

                    if (imageChestType == selected_chest_type) {
                      let productImageSrc = buildResizedImageInCollectionGrid(
                        element.src,
                        500
                      );
                      if (
                        productMainImage == "" &&
                        active_color == image_color_name
                      ) {
                        productMainImage = productImageSrc;
                        $(`#product_main_image_${product_id}`).attr(
                          "src",
                          productMainImage
                        );
                      } else if (
                        productHoverImage == "" &&
                        active_color == image_color_name
                      ) {
                        productHoverImage = productImageSrc;
                        $(`#product_hover_image_${product_id}`).attr(
                          "src",
                          productHoverImage
                        );
                      }
                      if (arrImageInfo[1]) {
                        $(`#all_images_for_color_${product_id}`).append(
                          `<img class="product-color-images-chest-type" style="display: none" data-color-name="${image_color_name}" src="${productImageSrc}" />`
                        );
                      }
                    }
                  }
                }
              }
            }
          });
        },
        dataType: "json",
      });
    });
  } else {
    $(".recommendation-product-card").each(function () {
      let productElement = $(this);
      let active_color = $(this)
        .find("span.product-card__color.active")
        .data("option");
      let product_handle = productElement.data("product-handle");
      let product_id = productElement.data("product-id");
      let productMainImage = "";
      let productHoverImage = "";

      $(`#all_images_for_color_${product_id}`).empty();

      $(this).find(`.product-card__colors span`).first().click();

      $.ajax({
        url: `/products/${product_handle}.js`,
        success: function (dataRes) {
          dataRes.media.forEach((element) => {
            if (element.alt != "" && element.alt != null) {
              let arrImageInfo = element.alt.split(" / ");

              let productImageSrc = buildResizedImageInCollectionGrid(
                element.src,
                500
              );

              if (arrImageInfo[1]) {
                $(`#all_images_for_color_${product_id}`).append(
                  `<img class="product-color-images-chest-type" style="display: none" data-color-name="${arrImageInfo[0]}" src="${productImageSrc}" />`
                );
              }

              if (productMainImage == "" && active_color == arrImageInfo[0]) {
                productMainImage = productImageSrc;
                $(`#product_main_image_${product_id}`).attr(
                  "src",
                  productMainImage
                );
              } else if (
                productHoverImage == "" &&
                active_color == arrImageInfo[0]
              ) {
                productHoverImage = productImageSrc;
                $(`#product_hover_image_${product_id}`).attr(
                  "src",
                  productHoverImage
                );
              }
            }
          });
        },
        dataType: "json",
      });
    });
  }
}


function selectColorImage(product_id, image_url, color_name) {
    let isRecommendedProduct = $(`[data-product-id="${product_id}"]`).hasClass('recommendation-product-card');

    if (isRecommendedProduct) {
        // Old logic for recommended products
        if (image_url != "") {
            let color_image_src = "";
            let color_hover_image = "";
            $(`[data-product-id="${product_id}"] .product-color-images-chest-type`).each(function () {
                let image_color_name = $(this).data("color-name");
                if (image_color_name == color_name && color_image_src == "") {
                    color_image_src = $(this).attr("src");
                } else if (image_color_name == color_name && color_hover_image == "") {
                    color_hover_image = $(this).attr("src");
                }
            });

            if (color_image_src != "") {
                $(`#product_main_image_${product_id}`).attr("src", color_image_src);
                if (color_hover_image != "") {
                    $(`#product_hover_image_${product_id}`).attr("src", color_hover_image);
                }
            } else {
                $(`#product_main_image_${product_id}`).attr("src", image_url);
            }
        }
    } else {
        // New logic for other products
        let color_image_src = "";
        let color_hover_image = "";
        let color_image_alt = "";
        let color_hover_alt = "";
        let imagesFound = 0;

        $(`[data-product-id="${product_id}"] .product-color-images-chest-type`).each(function () {
            let image_color_name = $(this).data("color-name");
            if (image_color_name == color_name) {
                let thisImageSrc = $(this).attr("data-imgsrc");
                let thisImageAlt = $(this).attr("alt");
                if (color_image_src == "") {
                    color_image_src = thisImageSrc;
                    color_image_alt = thisImageAlt;
                    imagesFound++;
                } else if (imagesFound == 1) {
                    color_hover_image = thisImageSrc;
                    color_hover_alt = thisImageAlt;
                    imagesFound++;
                    return false; // Stop looping
                }
            }
        });

        if (imagesFound > 0) {
            $(`#product_main_image_${product_id}`).attr("src", color_image_src).attr("alt", color_image_alt);
            if (imagesFound > 1 && color_hover_image != "") {
                $(`#product_hover_image_${product_id}`).attr("src", color_hover_image).attr("alt", color_hover_alt);
            }
        } else {
            $(`#product_main_image_${product_id}`).attr("src", image_url).attr("alt", "Default alt text");
        }
    }
}

function setDefaultChestTypeOnPDP() {
  let chest_type_from_cookie = getCookie("chest-type");
  if (availableChestTypes.indexOf(chest_type_from_cookie) !== -1) {
    $(".types-selection__wrapper .type-option").each(function () {
      let option = $(this).data("option");
      if (option == chest_type_from_cookie) {
        let element = $(this);
        setTimeout(function (element) {
          $(
            `.types-selection__wrapper .type-option[data-option="${option}"]`
          ).click();
        }, 1000);
      }
    });
  }
}

function redirectCollectionToChestType() {
  let chest_type_from_cookie = getCookie("chest-type");
  if (availableChestTypes.indexOf(chest_type_from_cookie) !== -1) {
    chest_type_from_cookie = chest_type_from_cookie.toLowerCase();
    chest_type_from_cookie = chest_type_from_cookie.replace(" ", "-");

    if (
      typeof document.location.search != "undefined" &&
      document.location.search != ""
    ) {
      document.location.href = `${document.location.origin}${document.location.pathname}/type-${chest_type_from_cookie}${document.location.search}`;
    } else {
      document.location.href = `${document.location.href}/type-${chest_type_from_cookie}`;
    }
  }
}

function setChestType(name) {
  if (name == "clear-type") {
    setCookie("chest-type", "", 0);
  } else {
    if (availableChestTypes.indexOf(name) !== -1) {
      setCookie("chest-type", name, 5);
    }
  }
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function buildResizedImageInCollectionGrid(image, max_width) {
  if (image) {
    image = image.replace(/.png/i, `_${max_width}x.png`);
    image = image.replace(/.jpg/i, `_${max_width}x.jpg`);
    image = image.replace(/.jpeg/i, `_${max_width}x.jpeg`);
    image = image.replace(/.gif/i, `_${max_width}x.gif`);
  }
  return image;
}
